/**
 * Handles a queued online task to mark as order as confirmed (OnlineTaskType.CONFIRM_ORDER).
 * Simply calls the API to confirm the order.
 *
 * @param {OnlineTask} task
 * @param {OrdersApi} ordersApi
 */
const confirmOrderTaskHandler = (task, ordersApi) => {
    return ordersApi.confirmOrder(task.data.orderID);
};

module.exports = confirmOrderTaskHandler;
